import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Home, NAVP } from './pages/Home';
import { Route, Routes } from 'react-router';
import { NotFound404 } from './pages/NotFound';
import { Footer } from './component/Footer';
import { AdminDashboard } from './pages/Admin';
import { NotasLeer } from './pages/NotasLeer';
import { LoginForm } from './pages/Logins';
import { NAV } from './component/NAV';
import { Blogs } from './pages/Blogs';
import { SobreMi } from './pages/SobreMi';

function App() {
  return (
    <div className="bg-dark">
      <NAV />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path="/membresia" element={<LoginForm />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path='/dashboard' element={<AdminDashboard />} />
        <Route path="/notas/:id" element={<NotasLeer />} />
        <Route path="/sobre-mi" element={<SobreMi />} />
        <Route path='*' element={<NotFound404 />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
